import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '../config/gameConfig.js';

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameOver' });
  }

  create(_data) {
    const teardownDom = this.registry.get('gameOverOverlayTeardown');

    const bg = this.add.graphics();
    bg.fillGradientStyle(0x301010, 0x180808, 0x120606, 0x080303, 1);
    bg.fillRect(0, 0, GAME_WIDTH, GAME_HEIGHT);
    bg.setDepth(-10);

    this.events.once('shutdown', () => {
      if (typeof teardownDom === 'function') teardownDom();
    });
  }
}
